import React from "react";
import { Box, Typography } from "@mui/material";
import { priorityValueColor } from "../../utils/constant";

// Horizontal High/Medium/Low meter row. Each bar's fill is relative to the
// three counts on this card (not some global max), so a card's own bars are
// always readable regardless of what other cards show.
const PriorityBreakdown = ({ priority }) => {
  const items = priority || [];
  const localTotal = items.reduce((sum, item) => sum + (item?.count || 0), 0);

  return (
    <Box>
      {items.map((item) => {
        const pct = localTotal
          ? Math.round(((item?.count || 0) / localTotal) * 100)
          : 0;
        return (
          <Box
            key={item?.status}
            display="flex"
            alignItems="center"
            gap="0.4rem"
            mb="0.35rem"
          >
            {/* Label */}
            <Typography
              fontSize={"0.72rem"}
              color={"#555"}
              width={"3.2rem"}
              flexShrink={0}
            >
              {item?.title}
            </Typography>

            {/* Progress bar track */}
            <Box
              flex={1}
              bgcolor={"#EBEBEB"}
              borderRadius={"3px"}
              height={"6px"}
              overflow={"hidden"}
            >
              <Box
                width={`${pct}%`}
                height={"100%"}
                bgcolor={priorityValueColor[item?.status]}
                borderRadius={"3px"}
                sx={{ transition: "width 0.4s ease" }}
              />
            </Box>

            {/* Count */}
            <Typography
              fontSize={"0.72rem"}
              color={"#555"}
              width={"1.5rem"}
              textAlign={"right"}
              flexShrink={0}
            >
              {item?.count ?? 0}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

export default PriorityBreakdown;
